import { InputSwitch } from 'primereact/inputswitch';
import React, { useState } from 'react';
import { putBrandStorePrice } from '../../../services/StorePriceCode/getPriceCode';

const StorePackageStatusChange = ({ status, editData, sendDataToStoreConfig, brandId }) => {
  const [statusValue, setStatusValue] = useState(status);

  const handleEditData = (e) => {
    const newStatus = e.value;
    setStatusValue(newStatus);

    const updatedData = {
      store: {
        id: editData.storeId,
      },
      userId: editData.userId,
      status: newStatus,
      id: editData.id,
    };

    //  const updatedData = {
    //    store: {
    //      id: editData.store.id,
    //    },
    //    userId: editData.userId,
    //    status: newStatus,
    //    id: editData.id,
    //  };

    putBrandStorePrice(brandId, updatedData)
      .then((response) => {
        if (!response.data.error) {
          sendDataToStoreConfig({
            success: true,
          });
        }
      })
      .catch((err) => {
        console.error('Error:', err);
      });
  };

  return (
    <div style={{ margin: '10px 0 10px 5px' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          borderRadius: '15px',
          width: '100%',
        }}
      >
        <InputSwitch checked={statusValue} onChange={handleEditData} />
      </div>
    </div>
  );
};

export default StorePackageStatusChange;
